import type { VertexStyle } from '../../../mesh/meshBuilder';
import { LANDMARK_PATTERN, patterned } from '../surfacePatterns';
import type { FortressStyles } from './fortressParts';

/**
 * The stone in the gate's lower walls (docs/plans/landmarks.md, section 9.5), in the walls' and the
 * trims' own colours:
 * - Gobertange speklagen every 20 to 27 courses on every part of the hoofdpoort but its Geldersekade
 *   front, up to about 5.5 m over today's ground (De Graauw, Bulletin KNOB 2011, p. 121), 5.8 m here;
 * - Ledesteen bands every 10 to 11 courses on the round bodies of K and TA (AAR 95, pp. 30-31);
 * - the sandstone shells of their octagonal plinths, in courses 46 cm high (AAR 95, p. 30).
 */
export interface WaagStone {
  readonly gobertange: VertexStyle;
  readonly ledesteen: VertexStyle;
  readonly sandstone: VertexStyle;
}

export function waagStone(styles: FortressStyles): WaagStone {
  return {
    gobertange: patterned(styles.wall, LANDMARK_PATTERN.gobertange),
    ledesteen: patterned(styles.wall, LANDMARK_PATTERN.ledesteen),
    sandstone: patterned(styles.trim, LANDMARK_PATTERN.sandstone),
  };
}
